import React,  { useState } from 'react'

import axios from 'axios';

import { ListBox } from 'primereact/listbox'

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import chatScript from "../ChatScript.json"

import InnerBotAvatar from './InnerBotAvatar'

import BotMessage from '../BotMessage'

import UserMessage from '../UserMessage'

import { Button } from 'primereact/button'

import { MzInputText } from '../../components'

import Functions from '../utils/Functions'






export default  function AddressAutocomplete({ message, isLastBotMessage, setMessages, setIsTyping, messages, answers, setAnswers, urlBotImage }) {
 const [buttonDisabled, setButtonDisabled] = React.useState(true);
 
    const [locations, setLocations] = useState([]);
  
 
  
  const fetchLocations = async (query) => {
        if (query) {
            const response = await axios.get(`https://nominatim.openstreetmap.org/search?q=${query}&format=json`);
            const locationItems = response.data.map((item) => ({
                label: item.display_name,
                value: item,
            }));
            setLocations(locationItems);
        } else {
            setLocations([]);
        }
  };
  
  const handleSearch = (event) => {
        fetchLocations(event.target.value);
		
		if (event.target.value.length >= 5) {
            setButtonDisabled(false)
        } else {
            setButtonDisabled(true)
        }
    };
  
 



  function handleSelect(msg,value) {
    document.getElementById("input_" + msg.id).value=value.display_name;
	setLocations([]);
	
  }

 


    function onClick(msg, setMessages, setIsTyping) {

        let value = document.getElementById("input_" + message.id).value


        const newAnswers = { ...answers }
        newAnswers[msg.chiave_domanda] = value
        setAnswers(newAnswers)
        //  console.log(newAnswers)

        const next =  Functions.getMessageById(msg.prossima)

          // Aggiorna il messaggio corrente con il valore dell'input
          const updatedMessages = messages.map((msg) => {
            if (msg.id === message.id) {
                return { ...msg, inputValue: value };
            }
            return msg;
        });

  

        if (next) {
            setIsTyping(true)
            setTimeout(() => {
                //debugger
                setIsTyping(false)
                //setMessages((prevMessages) => [...prevMessages, next])
                setMessages([...updatedMessages, next]);
            }, 1000)
        }

       

   

    }
	
    return (
        <div key={"bot" + message.id} >
            <div className='grid'>
                <InnerBotAvatar urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} />
                <div className='col-11'>
                    <BotMessage msg={message} isLastBotMessage={isLastBotMessage}></BotMessage>
                </div>


            </div>
            {!message.inputValue ? (
            <div className="grid">
                <div className='col-9 col-offset-1'>
                    <MzInputText onChange={handleSearch} stateValue={message.inputValue} placeholder={message.placeholder} id={"input_" + message.id} className={"ml-3"} ></MzInputText>
					<ListBox
						options={locations}
						onChange={(e) => handleSelect(message,e.value)}
						itemTemplate={(item) => <div>{item.label}</div>}
						listStyle={{ maxHeight: '300px' }}
					/>
				</div>
                <div className='col-2 '>
                    <Button disabled={buttonDisabled} onClick={() => onClick(message, setMessages, setIsTyping)} className='ml-2' label='>' />
                </div>
            </div>
            )
             :  <UserMessage msg={message}></UserMessage>}

        </div>
    )	
}
















